import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-end items-center py-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-cebai-grey-dark leading-snug pr-2 mr-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Please sign up or log in to start saving and developing ideas "),
  /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Please sign up or log in ")
], -1)
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 1,
  class: "flex justify-end items-center py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChallengeNavigation = _resolveComponent("ChallengeNavigation")!
  const _component_ChallengeHeader = _resolveComponent("ChallengeHeader")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Ribbon = _resolveComponent("Ribbon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_ChallengeNavigation),
        _createVNode(_component_ChallengeHeader, { "is-editable": true })
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "grey"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Tabs, {
          "active-tab": _ctx.activeTab,
          "uses-router": true,
          "has-content": false,
          tabs: _ctx.tabs,
          "tab-type": "underlined"
        }, null, 8, ["active-tab", "tabs"])
      ]),
      _: 1
    }),
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "primary"
    }, {
      default: _withCtx(() => [
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AppButton, {
                  type: "secondary",
                  class: "mr-2 whitespace-nowrap",
                  onClick: _ctx.toggleSignUp
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sign Up ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_AppButton, {
                  type: "primary",
                  class: "whitespace-nowrap",
                  onClick: _ctx.toggleLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log in")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : (_ctx.challenge?._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AppButtonRouterLink, {
                  to: { name: 'challenge-saved-ideas' },
                  type: "primary",
                  disabled: _ctx.ideaCount === 0
                }, {
                  iconAfter: _withCtx(() => [
                    _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Your ideas (" + _toDisplayString(_ctx.ideaCount) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}